import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import publicAxios from "../../utils/axios/publicAxios";
import "./ManageQuestionnaireResponse.css";
import moment from "moment";

const ManageQuestionnaireResponse = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [responseData, setResponseData] = useState(null);
  const [collapsedSections, setCollapsedSections] = useState({});
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const fetchResponse = async () => {
      try {
        const res = await publicAxios.get(`/public/manage-questionnaire-response/${slug}`);
        if (res.data.success) {
          setResponseData(res.data.response);
        } else {
          setMessage("⚠️ Could not load response.");
        }
      } catch (error) {
        console.error("Error fetching response:", error);
        setMessage("❌ Error fetching questionnaire response.");
      } finally {
        setLoading(false);
      }
    };

    fetchResponse();
  }, [slug]);

  const toggleSection = (index) => {
    setCollapsedSections((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  if (loading) {
    return (
      <div className="response-loading">
        <p>Loading response...</p>
      </div>
    );
  }

  if (!responseData) {
    return (
      <div className="response-error">
        <p>{message || "Response not found."}</p>
      </div>
    );
  }

  return (
    <div className="manage-response-container">
      {/* Header */}
      <div className="response-header">
        <h1>{responseData.questionnaire?.title || "Questionnaire Response"}</h1>
        <p>
          <strong>Respondent:</strong>{" "}
          {responseData.respondent
            ? `${responseData.respondent.firstname} ${responseData.respondent.lastname}`
            : "Anonymous"}
        </p>
        <p>
          <strong>Submitted:</strong>{" "}
          {moment(responseData.submittedAt).format("MMM DD, YYYY [at] HH:mm")}
        </p>
      </div>

      {/* Sections */}
      {responseData.responses.map((section, sIndex) => {
        const collapsed = collapsedSections[sIndex];
        return (
          <div key={sIndex} className="response-section">
            <div
              className="response-section-header"
              onClick={() => toggleSection(sIndex)}
            >
              <h2>{section.sectionTitle}</h2>
              <span className="toggle-icon">{collapsed ? "▶" : "▼"}</span>
            </div>

            {!collapsed && (
              <div className="response-section-content">
                {section.questions.map((q, qIndex) => (
                  <div key={qIndex} className="response-item">
                    <p className="question-text">❓ {q.question}</p>
                    {Array.isArray(q.answer) ? (
                      <ul className="multi-answer">
                        {q.answer.map((a, i) => (
                          <li key={i}>✅ {a}</li>
                        ))}
                      </ul>
                    ) : (
                      <p className="answer-text">💬 {q.answer || "—"}</p>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}

      {/* Back button */}
      <div className="response-footer">
        <button className="back-btn" onClick={() => navigate(-1)}>
          ⬅ Back
        </button>
      </div>

      {message && <p className="status-message">{message}</p>}
    </div>
  );
};

export default ManageQuestionnaireResponse;